<div [class]="field.styleValue" [attr.lang]="metadataValue.language">
    <span class="link-value">
      <a href="{{link.href}}" target="_blank">{{ link.text }}</a>
    </span>
</div>
